// This file was once generated when you created this area
// but you can edit it freely

const baseRoute = '/fleet-management-testing'

export const FleetManagementTestingAreaRoutes = {
  route: baseRoute,
  path: '/',
  SimulatorList: {
    route: baseRoute,
  },
  Simulator: {
    route: `${baseRoute}/simulator/:vehicleId`,
    path: 'simulator/:vehicleId',
  },
  AvailableVehicles: {
    route: `${baseRoute}/available-vehicles`,
    path: 'available-vehicles',
  },
  Optimization: {
    route: `${baseRoute}/optimization`,
    path: 'optimization',
  },
  OptimizationDetails: {
    route: `${baseRoute}/optimization/:vehicleId`,
    path: 'optimization/:vehicleId',
  },
}
